import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import { Box, Button } from '@mui/material';
import { Print } from '@mui/icons-material';

const LabelPrinter = ({ obj }) => {
    const labelRef = useRef();
    const barcodeRef = useRef();

    const printLabel = () => {
        if (labelRef.current) {
            const printWindow = window.open('', '_blank');
            printWindow.document.write('<html><head><title>Print Label</title>');
            printWindow.document.write(
                '<style>@media print { body { margin: 0; } }</style>'
            );
            printWindow.document.write('</head><body>');
            printWindow.document.write(labelRef.current.outerHTML);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        }
    };

    const generateBarcode = () => {
        if (barcodeRef.current) {
            JsBarcode(barcodeRef.current, `${obj.id}`, {
                format: 'CODE128',
                lineColor: '#000',
                width: 2,
                height: 40,
                displayValue: true,
            });
        }
    };

    useEffect(()=>{
        generateBarcode();
    },[])

    return (
        <div>
            <Button variant="outlined" size="small" startIcon={<Print />} onClick={() => { generateBarcode(); printLabel(); }}>
                Label
            </Button>

            {/* Hidden label area for printing */}
            <Box sx={{height:0,width:0}}>

            
            <div
                ref={labelRef}
                style={{
                    width: '10cm',
                    height: '5cm',
                    padding: '10px',
                    boxSizing: 'border-box',
                    border: '1px solid #000',
                    fontFamily: 'Arial, sans-serif',
                }}
            >
                <div style={{ fontSize: '16pt', marginBottom: '10px' }}>
                    {obj.text}
                </div>
                <div style={{ fontSize: '14pt', marginBottom: '10px' }}>
                    Number: {obj.id}
                </div>
                <Box component="canvas" sx={{width:'200px', height:'30px', backgroundColor:'#f0f'}} ref={barcodeRef} />
            </div>
            </Box>
        </div>
    );
};

export default LabelPrinter;
